/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EventSchema,
  HTTPValidationError,
  PageEventSchema,
} from '../models';
import {
    EventSchemaFromJSON,
    EventSchemaToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PageEventSchemaFromJSON,
    PageEventSchemaToJSON,
} from '../models';

export interface CreateEventEventsPostRequest {
    eventSchema: EventSchema;
}

export interface DeleteEventEventsIdDeleteRequest {
    id: number;
}

export interface GetCurrentEventsEventsCurrentGetRequest {
    configurationId?: number | null;
    page?: number;
    size?: number;
}

export interface GetEventEventsIdGetRequest {
    id: number;
}

export interface GetEventsEventsGetRequest {
    page?: number;
    size?: number;
}

export interface SearchEventsByMmsiEventsSearchGetRequest {
    mmsi: number;
    mmsiOther?: number | null;
    configurationId?: number | null;
    page?: number;
    size?: number;
}

export interface UpdateEventEventsIdPutRequest {
    id: number;
    eventSchema: EventSchema;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Create Event
     */
    async createEventEventsPostRaw(requestParameters: CreateEventEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventSchema>> {
        if (requestParameters.eventSchema === null || requestParameters.eventSchema === undefined) {
            throw new runtime.RequiredError('eventSchema','Required parameter requestParameters.eventSchema was null or undefined when calling createEventEventsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventSchemaToJSON(requestParameters.eventSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventSchemaFromJSON(jsonValue));
    }

    /**
     * Create Event
     */
    async createEventEventsPost(requestParameters: CreateEventEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventSchema> {
        const response = await this.createEventEventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Event
     */
    async deleteEventEventsIdDeleteRaw(requestParameters: DeleteEventEventsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteEventEventsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Event
     */
    async deleteEventEventsIdDelete(requestParameters: DeleteEventEventsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventEventsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get Current Events
     */
    async getCurrentEventsEventsCurrentGetRaw(requestParameters: GetCurrentEventsEventsCurrentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageEventSchema>> {
        const queryParameters: any = {};

        if (requestParameters.configurationId !== undefined) {
            queryParameters['configuration_id'] = requestParameters.configurationId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageEventSchemaFromJSON(jsonValue));
    }

    /**
     * Get Current Events
     */
    async getCurrentEventsEventsCurrentGet(requestParameters: GetCurrentEventsEventsCurrentGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageEventSchema> {
        const response = await this.getCurrentEventsEventsCurrentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Event
     */
    async getEventEventsIdGetRaw(requestParameters: GetEventEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEventEventsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventSchemaFromJSON(jsonValue));
    }

    /**
     * Get Event
     */
    async getEventEventsIdGet(requestParameters: GetEventEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventSchema> {
        const response = await this.getEventEventsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Events
     */
    async getEventsEventsGetRaw(requestParameters: GetEventsEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageEventSchema>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageEventSchemaFromJSON(jsonValue));
    }

    /**
     * Get Events
     */
    async getEventsEventsGet(requestParameters: GetEventsEventsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageEventSchema> {
        const response = await this.getEventsEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search Events By Mmsi
     */
    async searchEventsByMmsiEventsSearchGetRaw(requestParameters: SearchEventsByMmsiEventsSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageEventSchema>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling searchEventsByMmsiEventsSearchGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.mmsi !== undefined) {
            queryParameters['mmsi'] = requestParameters.mmsi;
        }

        if (requestParameters.mmsiOther !== undefined) {
            queryParameters['mmsi_other'] = requestParameters.mmsiOther;
        }

        if (requestParameters.configurationId !== undefined) {
            queryParameters['configuration_id'] = requestParameters.configurationId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageEventSchemaFromJSON(jsonValue));
    }

    /**
     * Search Events By Mmsi
     */
    async searchEventsByMmsiEventsSearchGet(requestParameters: SearchEventsByMmsiEventsSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageEventSchema> {
        const response = await this.searchEventsByMmsiEventsSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Event
     */
    async updateEventEventsIdPutRaw(requestParameters: UpdateEventEventsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateEventEventsIdPut.');
        }

        if (requestParameters.eventSchema === null || requestParameters.eventSchema === undefined) {
            throw new runtime.RequiredError('eventSchema','Required parameter requestParameters.eventSchema was null or undefined when calling updateEventEventsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EventSchemaToJSON(requestParameters.eventSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventSchemaFromJSON(jsonValue));
    }

    /**
     * Update Event
     */
    async updateEventEventsIdPut(requestParameters: UpdateEventEventsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventSchema> {
        const response = await this.updateEventEventsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
